// extracted by mini-css-extract-plugin
module.exports = {"all_highlights":"Highlights_all_highlights__3eQn9","single_highlight":"Highlights_single_highlight__1czjQ"};